<template>
  <ToolAdmin
    :user="user"
    tool-id="CustomerServiceArtificialAgent"
    tool-name="Artificial Agent"
    tool-icon="mdi-android"
  />
</template>

<script>
import ToolAdmin from './ToolAdmin.vue'

export default {
  name: 'ArtificialAgentAdmin',
  components: {
    ToolAdmin
  },
  props: ['user']
}
</script> 